var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefocusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 10C4.16667 10.766 4.31755 11.5246 4.6107 12.2323C4.90385 12.9401 5.33354 13.5831 5.87521 14.1248C6.41689 14.6665 7.05995 15.0961 7.76768 15.3893C8.47541 15.6824 9.23396 15.8333 10 15.8333M4.16667 10C4.16667 9.23396 4.31755 8.47541 4.6107 7.76768C4.90385 7.05995 5.33354 6.41689 5.87521 5.87521C6.41689 5.33354 7.05995 4.90385 7.76768 4.6107C8.47541 4.31755 9.23396 4.16667 10 4.16667M4.16667 10H2.5M10 15.8333C10.766 15.8333 11.5246 15.6824 12.2323 15.3893C12.9401 15.0961 13.5831 14.6665 14.1248 14.1248C14.6665 13.5831 15.0961 12.9401 15.3893 12.2323C15.6824 11.5246 15.8333 10.766 15.8333 10M10 15.8333V17.5M15.8333 10C15.8333 9.23396 15.6824 8.47541 15.3893 7.76768C15.0961 7.05995 14.6665 6.41689 14.1248 5.87521C13.5831 5.33354 12.9401 4.90385 12.2323 4.6107C11.5246 4.31755 10.766 4.16667 10 4.16667M15.8333 10H17.5M10 4.16667V2.5M2.5 2.5L10 10L17.5 17.5M10.4167 10C10.4167 10.2301 10.2301 10.4167 10 10.4167C9.76988 10.4167 9.58333 10.2301 9.58333 10C9.58333 9.76988 9.76988 9.58333 10 9.58333C10.2301 9.58333 10.4167 9.76988 10.4167 10Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefocusIcon);
export default __webpack_public_path__ + "static/media/defocusIcon.f15af11eb79cc99b782e6678aa2f68bd.svg";
export { ForwardRef as ReactComponent };